import { Heading, HStack, VStack } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type OfferingBreakdownProps = {
  children?: React.ReactNode;
};

export const OfferingBreakdown: React.FC<OfferingBreakdownProps> = () => {
  const { property } = usePropertiesModel();
  if (!property?.sfr?.offering_breakdown.data) return null;
  const title = 'Offering Breakdown';
  const { data } = property.sfr.offering_breakdown;
  const _id = title.toLowerCase().replace(' ', '-');
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Heading
        id={_id}
        letterSpacing={-0.8}
        fontWeight={'normal'}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontSize={['28px', '36px']}>
        {title}
      </Heading>
      <TextBlock>These data are estimates and are subject to change.</TextBlock>
      {data.map((item, i) =>
        item.highlight ? (
          <VStack
            backgroundColor={'gray.50'}
            key={`${item.title}`}
            w="full"
            py={30}
            borderRadius={'10px'}
            borderWidth={1}
            borderColor={'gray.200'}>
            <TextBlock fontSize={[14, 14, 20]}>{item.title}</TextBlock>
            <TextBlock
              fontSize={[20, 20, 40]}
              lineHeight={['40px', '40px', '40px']}
              weight="bold"
              color="blue"
              background="linear-gradient(-90deg, #308EFF 0%, #034089 100%)"
              backgroundClip="text">
              {item.description}
            </TextBlock>
          </VStack>
        ) : (
          <HStack
            key={`${item.title}`}
            lineHeight={['40px', '40px', '84px']}
            w="full"
            justifyContent={'space-between'}
            borderBottomWidth={data[i + 1]?.highlight ? 0 : 1}
            borderBottomColor={'gray.200'}>
            <TextBlock color="gray.500" fontSize={[14, 14, 20]}>
              {item.title}
            </TextBlock>
            <TextBlock fontSize={[14, 14, 20]} weight="bold">
              {item.description}
            </TextBlock>
          </HStack>
        ),
      )}
    </VStack>
  );
};
